import { ContentCopy } from '@mui/icons-material';
import { IconButton, Stack, Tooltip } from '@mui/material';

type CopyTextProps = {
  readonly text: string;
  readonly bold?: boolean;
};

export const CopyText = ({ text, bold }: CopyTextProps) => {
  const copyToClipboard = async () => {
    await navigator.clipboard.writeText(text);
  };

  return (
    <Stack direction="row" alignItems="center">
      <div
        style={{
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          minWidth: 0,
          paddingRight: 6,
          fontWeight: bold ? 'bold' : '',
        }}
      >
        {text}
      </div>
      <Tooltip title="Klicken zum Kopieren">
        <IconButton
          onClick={copyToClipboard}
          color="primary"
          style={{ marginTop: '-8px', marginBottom: '-8px', marginLeft: '-4px' }}
        >
          <ContentCopy sx={{ fontSize: '1rem' }} />
        </IconButton>
      </Tooltip>
    </Stack>
  );
};
